type PasswordErrorTranslator = (
  key: string,
  options?: Record<string, unknown>,
) => unknown;

export function getAccountPasswordErrorMessage(
  error: unknown,
  t: PasswordErrorTranslator,
) {
  const code =
    error && typeof error === "object" && "code" in error
      ? error.code
      : undefined;

  if (code === "INVALID_CURRENT_PASSWORD") {
    return String(t("settings.accountEdit.currentPasswordIncorrect"));
  }

  return error instanceof Error
    ? error.message
    : String(t("settings.accountEdit.errorGeneric"));
}
